const collator = new Intl.Collator('en-US', {
  numeric: true,
  sensitivity: 'base',
})

export default function useCollator() {
  return collator
}
